import { Typography } from '@mui/material';
import React from 'react';

const NotFound = () => {
  return (
    <div
      style={{
        margin: '0 auto',
      }}
    >
      <Typography variant='h1' noWrap component='div'>
        Not Found
      </Typography>
      <p>Sorry, this page does not exist</p>
    </div>
  );
};

export default NotFound;
